import { render, staticRenderFns } from "./company-details-contacts-form-container.vue?vue&type=template&id=0b0c89ce&scoped=true&lang=pug"
import script from "./company-details-contacts-form-container.vue?vue&type=script&lang=ts"
export * from "./company-details-contacts-form-container.vue?vue&type=script&lang=ts"
import style0 from "./company-details-contacts-form-container.vue?vue&type=style&index=0&id=0b0c89ce&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b0c89ce",
  null
  
)

export default component.exports